import * as React from 'react';
import * as styles from './Table.css';
import { Controller } from '../controller/Controller';
import { inject, observer } from 'mobx-react';
import { Store } from '../stores';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAButton } from '../../button/Button';
import { Helper } from '../../../Helper';

export interface IProps {
  store?: Store;
  id: string;
  index: number;
  table: string;
  hideToolbox: boolean;
  showDropZones: boolean;
  onChange: (table: string) => void;
  onFocus: () => void;
  onDrag: () => void;
  onDragEnd: () => void;
}

export interface IState {
  showController: boolean;
  showDropZones: boolean;
  rows: any[];
  columsCount: number;
  currentRowIndex: number;
  currentColumnIndex: number;
}

@inject('store')
@observer
export class Table extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();
  private defaultTable;

  constructor(props: IProps) {
    super(props);
    this.state = {
      showController: false,
      showDropZones: false,
      rows: [],
      columsCount: undefined,
      currentRowIndex: undefined,
      currentColumnIndex: undefined,
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
    this.defaultTable = "<table><tr><th></th><th></th><th></th></tr><tr><th></th><th></th><th></th></tr><tr><th></th><th></th><th></th></tr></table>";
  }

  public componentDidMount(): void {
    const currentTableEditor = document.getElementById(`IA_TableEditor_${this.props.id}`);
    currentTableEditor.addEventListener("paste", (e: any) => {
      if (this.props.id === this.props.store.activeComponent.id) {
        const rows = this.state.rows;
        // cancel paste
        e.preventDefault();
        // get text representation of clipboard
        var text = (e.originalEvent || e).clipboardData.getData('text/plain');
        // insert text manually

        const selection: any = window.getSelection();
        const node: any = selection.anchorNode;
        if (node.length) {
          const currentContent = e.target.innerText;
          rows[this.state.currentRowIndex].columns[this.state.currentColumnIndex].content = currentContent.substring(0, selection.anchorOffset) + text + currentContent.substring(selection.anchorOffset);
        } else {
          rows[this.state.currentRowIndex].columns[this.state.currentColumnIndex].content = text;
        }
        this.setState({ rows }, () => this.onChange());
        // Set focus after pasted content
        var setpos = document.createRange();
        var set = window.getSelection();
        setpos.setStart(e.target.childNodes[0], selection.anchorOffset + text.length);
        setpos.collapse(true);
        set.removeAllRanges();
        set.addRange(setpos);
        e.target.focus();
      }
    });
    this.hideToolbox();
    this.generateTable();
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.hideToolbox) {
      this.hideToolbox();
    }
    if (this.props.hideToolbox !== props.hideToolbox && props.hideToolbox != undefined && !props.hideToolbox) {
      this.setState({ showController: true });
    }
    if (props.showDropZones) {
      this.hideToolbox()
    }
    if (props.showDropZones !== this.props.showDropZones) {
      setTimeout(() => {
        this.setState({ showDropZones: props.showDropZones });
      }, 0);
    }
  }

  private generateTable(): void {
    const rows = [];
    let columsCount;
    const tableContainer: any = document.getElementById(`IA_Table_${this.props.id}`);
    if (tableContainer && tableContainer.firstChild) {
      const renderedTable = tableContainer.firstChild;
      for (var rowIndex = 0; rowIndex < renderedTable.rows.length; rowIndex++) {
        const columns = [];
        columsCount = renderedTable.rows[rowIndex].cells.length;
        for (var columnIndex = 0; columnIndex < renderedTable.rows[rowIndex].cells.length; columnIndex++) {
          columns.push(
            {
              content: renderedTable.rows[rowIndex].cells[columnIndex].innerHTML,
              style: {
                borderColor: renderedTable.rows[rowIndex].cells[columnIndex].style.borderColor ? Helper.convertRbToHex(renderedTable.rows[rowIndex].cells[columnIndex].style.borderColor) : "#cbcbcb",
                backgroundColor: renderedTable.rows[rowIndex].cells[columnIndex].style.backgroundColor ? Helper.convertRbToHex(renderedTable.rows[rowIndex].cells[columnIndex].style.backgroundColor) : undefined,
                color: renderedTable.rows[rowIndex].cells[columnIndex].style.color ? Helper.convertRbToHex(renderedTable.rows[rowIndex].cells[columnIndex].style.color) : undefined,
                fontWeight: renderedTable.rows[rowIndex].cells[columnIndex].style.fontWeight ? renderedTable.rows[rowIndex].cells[columnIndex].style.fontWeight : undefined,
                textAlign: renderedTable.rows[rowIndex].cells[columnIndex].style.textAlign ? renderedTable.rows[rowIndex].cells[columnIndex].style.textAlign : undefined,
              }
            }
          );
        }
        rows.push(
          {
            columns: columns,
            style: {
              backgroundColor: renderedTable.rows[rowIndex].style.backgroundColor ? Helper.convertRbToHex(renderedTable.rows[rowIndex].style.backgroundColor) : "#ffffff",
              color: renderedTable.rows[rowIndex].style.color ? Helper.convertRbToHex(renderedTable.rows[rowIndex].style.color) : "#000000",
              fontWeight: renderedTable.rows[rowIndex].style.fontWeight ? renderedTable.rows[rowIndex].style.fontWeight : "normal",
              textAlign: renderedTable.rows[rowIndex].style.textAlign ? renderedTable.rows[rowIndex].style.textAlign : "left",
            }
          }
        );
      }
    }
    this.setState({ rows, columsCount });
  }

  private addRow(): void {
    const rows = this.state.rows;
    const columns = [];
    for (var i = 0; i < this.state.columsCount; i++) {
      columns.push({
        content: undefined,
        style: {
          borderColor: "#cbcbcb"
        }
      });
    }
    rows.push({
      columns: columns,
      style: {
        backgroundColor: "#ffffff",
        color: "#000000",
        fontWeight: "normal",
        textAlign: "left",
      }
    });
    this.setState({ rows }, () => {
      this.updateBorderColor();
      this.onChange()
    });
  }

  private addColumn(): void {
    const rows = this.state.rows;
    rows.forEach((row: any) => {
      row.columns.push({
        content: undefined,
        style: {
          borderColor: "#cbcbcb"
        }
      });
    })
    this.setState({ rows, columsCount: this.state.columsCount + 1 }, () => {
      this.updateBorderColor();
      this.onChange()
    });
  }

  private updateBorderColor(): void {
    const table = document.getElementById(`IA_TableEditor_${this.props.id}`)
    let borderColor;
    if (table) {
      table.childNodes.forEach((row: any) => {
        row.childNodes.forEach((cell: any) => {
          if (!borderColor) {
            borderColor = cell.style.borderColor;
          }
          cell.style.borderColor = borderColor;
        })
      })
    }
  }

  private hideToolbox(): void {
    const editor = document.getElementById(this.props.id);
    const toolbox: any = editor ? editor.getElementsByClassName("ql-toolbar")[0] : undefined;
    if (toolbox) {
      toolbox.style.display = "none";
    }
    this.setState({ showController: false });
  }

  private onChange(): void {
    let rows = "";
    const tableEditor: any = document.getElementById(`IA_TableEditor_${this.props.id}`);
    if (tableEditor) {
      for (var i = 0; i < tableEditor.rows.length; i++) {
        let columns = "";
        for (var j = 0; j < tableEditor.rows[i].cells.length; j++) {
          columns += `<th style="${tableEditor.rows[i].cells[j].style.cssText}">${tableEditor.rows[i].cells[j].innerHTML}</th>`;
        }
        rows += `<tr style="${tableEditor.rows[i].style.cssText}">${columns}</tr>`;
      }
      this.props.onChange(`<table style="${tableEditor.style.cssText}">${rows}</table>`);
    }
  }

  public render(): JSX.Element {
    const rows = [];
    if (this.state.rows) {
      this.state.rows.forEach((row: any, rowIndex = 0) => {
        const columns = [];
        row.columns.forEach((column: any, columnIndex = 0) => {
          columns.push(
            <th
              id={`${this.props.id}--${rowIndex}-${columnIndex}`}
              contentEditable={true}
              onInput={() => {
                this.onChange();
              }}
              onSelect={() => {
                this.setState({
                  currentRowIndex: rowIndex,
                  currentColumnIndex: columnIndex
                });
              }}
              style={{
                borderColor: column.style?.borderColor ? column.style.borderColor : "#cbcbcb",
                backgroundColor: column.style?.backgroundColor ? column.style.backgroundColor : undefined,
                color: column.style?.color ? column.style.color : undefined,
                fontWeight: column.style?.fontWeight ? column.style.fontWeight : undefined,
                textAlign: column.style?.textAlign ? column.style.textAlign : undefined,
              }}
              dangerouslySetInnerHTML={{ __html: column.content}}
              >
            </th>
          );
        });
        rows.push(<tr style={{
          backgroundColor: row.style?.backgroundColor ? row.style.backgroundColor : "#ffffff",
          color: row.style?.color ? row.style.color : "#000000",
          fontWeight: row.style?.fontWeight ? row.style.fontWeight : "normal",
          textAlign: row.style?.textAlign ? row.style.textAlign : "left",
        }}>{columns}</tr>);
      });
    }
    const selection: any = window.getSelection();
    const parentNode: any = selection?.anchorNode?.parentNode;
    const cell = selection?.anchorNode?.nodeName === "TH" ? selection.anchorNode : (parentNode?.nodeName === "TH" ? parentNode : undefined);
    const row: any = parentNode?.parentNode?.nodeName === "TR" ? parentNode?.parentNode : (parentNode?.nodeName === "TR" ? parentNode : undefined);
    const table: any = document.getElementById(`IA_TableEditor_${this.props.id}`)
    return (
      <div
        id={"IA_table"}
        className={styles.IA_table}
        onClick={() => {
        }}
      >
        <Controller
          visible={this.state.showController && !this.state.showDropZones}
          highlightColor={this.props.store.highlightColor}
          onDublicate={() => this.props.store.dublicateComponent()}
          onDelete={() => {
            this.props.store.removeComponentAtIndex(this.props.index);
            this.hideToolbox()
            this.props.store.activeComponent = undefined;
            this.forceUpdate();
          }}
          onDrag={() => {
            this.props.onDrag();
          }}
          onDragEnd={() => this.props.onDragEnd()}
        />
        {
          this.state.showDropZones && this.props.index === 0 && !this.state.showController &&
          <div className={styles.IA_dropZones}
            style={{
              marginBottom: 10
            }}
            onDragOver={(event) => {
              event.preventDefault();
            }}
            onDragEnter={(event) => {
              event.preventDefault();
            }}
            onDropCapture={(event) => {
              event.preventDefault();
              if (this.props.store.startIndex != undefined) {
                this.props.store.moveComponentAtIndex(0);
              } else {
                this.props.store.addComponentAtIndex(0);
              }
            }}
          />
        }
        <table
          id={`IA_TableEditor_${this.props.id}`}
          onFocus={() => {
            this.props.onFocus();
          }}
        >
          {rows}
        </table>
        {this.state.showController &&
          <IAButton
            label={this.localizationService.strings.Composer_AddRow}
            buttonColor="transparent"
            textColor={"#333333"}
            icon="Add"
            height={22}
            iconColor={this.props.store.highlightColor}
            fontSize={14}
            dataAutomationId="subjects-add-new"
            onClick={() => this.addRow()}
            style={{
              position: "relative",
              float: "left",
              clear: "both",
              marginTop: 10,
              padding: 0
            }}
          />
        }
        {this.state.showController &&
          <IAButton
            label={this.localizationService.strings.Composer_AddColumn}
            buttonColor="transparent"
            textColor={"#333333"}
            icon="Add"
            height={22}
            iconColor={this.props.store.highlightColor}
            fontSize={14}
            dataAutomationId="subjects-add-new"
            onClick={() => this.addColumn()}
            style={{
              position: "relative",
              float: "left",
              marginTop: 10,
              marginLeft: 20,
              padding: 0
            }}
          />
        }
        {this.state.showController && table && row &&
          <IAButton
            label={this.localizationService.strings.Composer_DeleteSelectedRow}
            buttonColor="transparent"
            textColor={"#333333"}
            icon="Trash"
            height={22}
            iconColor={"#df4f4f"}
            fontSize={14}
            dataAutomationId="subjects-add-new"
            onClick={() => {
              table.deleteRow(row.rowIndex);
              this.onChange();
            }}
            style={{
              position: "relative",
              float: "left",
              marginTop: 10,
              marginLeft: 20,
              padding: 0
            }}
          />
        }
        {this.state.showController && table && row && cell &&
          <IAButton
            label={this.localizationService.strings.Composer_DeleteSelectedColumn}
            buttonColor="transparent"
            textColor={"#333333"}
            icon="Trash"
            height={22}
            iconColor={"#df4f4f"}
            fontSize={14}
            dataAutomationId="subjects-add-new"
            onClick={() => {
              table.childNodes.forEach((rowInTable) => {
                rowInTable.deleteCell(cell.cellIndex);
              });
              this.setState({ columsCount: this.state.columsCount - 1 }, () => this.onChange());
            }}
            style={{
              position: "relative",
              float: "left",
              marginTop: 10,
              marginLeft: 20,
              padding: 0
            }}
          />
        }
        <div
          id={`IA_Table_${this.props.id}`}
          style={{
            display: "none"
          }}
          dangerouslySetInnerHTML={{ __html: this.props.table ? this.props.table : this.defaultTable }}
        />
        {
          this.state.showDropZones && !this.state.showController &&
          <div
            className={styles.IA_dropZones}
            style={{
              marginTop: 10
            }}
            onDragOver={(event) => {
              event.preventDefault();
            }}
            onDragEnter={(event) => {
              event.preventDefault();
            }}
            onDropCapture={(event) => {
              event.preventDefault();
              if (this.props.store.startIndex != undefined) {
                this.props.store.moveComponentAtIndex(this.props.index + 1);
              } else {
                this.props.store.addComponentAtIndex(this.props.index + 1);
              }
            }}
          />
        }
      </div >
    );
  }
}